import React from "react";
import ErrorMessage from "../../../../components/common/ErrorMessage";
import Modal from "../../../../components/common/Modal";
import Button from "../../../../components/form/Button";

const DestinationTestModal = ({
  loading,
  errorMessage,
  onRequestClose,
  onClick,
}: {
  loading: boolean;
  errorMessage: string | null;
  onRequestClose: () => void;
  onClick: () => void;
}) => {
  return (
    <Modal
      className="p-8"
      width={550}
      onRequestClose={onRequestClose}
      isOpen={true}
    >
      <div className="space-y-5 text-gray-900">
        <div className="text-lg font-medium">Test Connection Required</div>
        <p className="text-sm text-gray-700">
          Connection settings changed. Test the connection before saving.
        </p>

        {errorMessage && (
          <ErrorMessage
            errorMessage={errorMessage}
            name="testConnectionError"
          />
        )}

        <div className="flex gap-3 pt-2">
          <Button
            variant="primary"
            loading={loading}
            onClick={onClick}
            className="min-w-[9rem]"
          >
            Test Connection
          </Button>
          <Button
            variant="default"
            onClick={onRequestClose}
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DestinationTestModal;
